// Copyright © 2023 CATTLEytics Inc.

import React, { useContext } from 'react';

import { SettingsAnimals, SettingsLocalization } from '../../shared/entities';

const DEFAULTS = {
  dateFormat: '',
  weightUnit: '',
  temperatureUnit: '',
  heightUnit: '',
  defaultUnits: '',
  language: '',
  timeFormat: '',
  timeZone: 'America/Toronto',
  preferredDateTimeStyle: 'absolute',
};

// @TODO rename to SettingsLocalizationContext
const SettingsContext = React.createContext<SettingsLocalization>(DEFAULTS);

export const SettingsAnimalsContext = React.createContext<SettingsAnimals>({
  typicalWeight: '680',
  // TODO: add appropriate default value
  typicalCalfWeight: '500',
});

// @TODO rename to SettingsLocalizationContext
export const SettingsContextProvider: React.FC<{
  value?: SettingsLocalization;
}> = ({ value, children }) => {
  return <SettingsContext.Provider value={value || DEFAULTS}>{children}</SettingsContext.Provider>;
};

export const useSettings = (): SettingsLocalization => {
  const settings = useContext(SettingsContext);
  if (!settings) {
    throw new Error('useSettings called out of context!');
  }
  return settings;
};
